import React, {useState} from 'react';
import {Script} from 'gatsby';

import Layout from '@Themes/natucare/components/Layout/Layout';
import Footer from '@Themes/natucare/modules/Footer/Footer';

import FooterV4 from '@Themes/natucare/modules/V4/Footer/Footer';

import Seo from '@/components/Seo/Seo';
import HeaderApi from '@/components/HeaderApi/HeaderApi';

import {useVisitorTracking} from '@ThemesApp/common/hooks/useVisitorTracking';
// import {useCopyToClipboard} from '@/hooks/useCopyToClipboard';

import './Base.module.scss';


/**
 * Layout template
 */
const Base = React.forwardRef((props, readingIndicatorRef) => {
  const {children, tidio, isBlogPostTemplate, headerData, footerData, isKlaviyoPl = false, locale = "intl"} = props;

  const isPlLocale = locale === 'pl';

  const isVisitorTrackingEnable = process.env.NODE_ENV === 'production';

  // T8ZJW2 - PL id 
  // WqmV9u - INTL id
  const klaviyoId = isKlaviyoPl ? 'T8ZJW2' : 'WqmV9u'

  useVisitorTracking(2, 'https://visitor.natu.care/track', isVisitorTrackingEnable);
  // useCopyToClipboard();

  const [subscriptionStatus, setSubscriptionStatus] = useState({
    isSending: false,
    isSubscribed: false,
    isEmailTaken: false
  });

  const handleSubscribeNewsletter = async (email, tags = 'newsletter') => {
    setSubscriptionStatus({
      isSending: true,
      isSubscribed: false,
      isEmailTaken: false
    });

    try {
      const response = await fetch('/api/subscribe-newsletter', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email,
          tags
        })
      });

      const data = await response.json();

      setSubscriptionStatus({
        isSending: false,
        isSubscribed: !data.errorCode,
        isEmailTaken: data.errorCode === 'EMAIL_ALREADY_TAKEN'
      });

      if (typeof data.errorCode === 'undefined' && data?.errorCode !== 'EMAIL_ALREADY_TAKEN') {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({'event': 'subscribe_nwl'});
      }

    } catch (error) {
      setSubscriptionStatus({
        isSending: false,
        isSubscribed: false,
        isEmailTaken: false
      });
    }
  };



  return <Layout>
    <Seo/>
    {isPlLocale
      ? <HeaderApi
        headerData={headerData}
        isBlogPostTemplate={isBlogPostTemplate}
        ref={readingIndicatorRef}
      />
      : <HeaderApi
        headerData={headerData}
        isBlogPostTemplate={isBlogPostTemplate}
        useLegacyHeader
        ref={readingIndicatorRef}
      />}
    <main>{children}</main>
    {isPlLocale
      ? <FooterV4
        {...footerData}
        onSubscribe={handleSubscribeNewsletter}
        subscriptionStatus={subscriptionStatus}
        locale={locale}
      />
      : <Footer
        {...footerData}
        onSubscribe={handleSubscribeNewsletter}
        subscriptionStatus={subscriptionStatus}
        locale={locale}
      />}


    <Script strategy='idle' src={`https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=${klaviyoId}`}/>
    {tidio && <Script strategy='idle' src='https://app.responso.com/settings/integration/chat/proxy/int_cha_4fde5608526804901830fad6942edd221c34173e9e5bf03cb2ddb26f710f8cde' async/>}
  </Layout>;
});

export default Base;
